import "./navbar.css";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

function Navbar() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    document.body.classList.toggle("menu-open", open);
    return () => document.body.classList.remove("menu-open");
  }, [open]);

  return (
    <div className="outer-nav">
      <div className="logo-container">
        <Link to="/">
          <img src="https://i.imgur.com/6IWXus4.png" className="logo" alt="" />
        </Link>
      </div>
      <nav className="navbar-container">
        <button className="hamburger" onClick={() => setOpen(!open)}>
          ☰
        </button>

        <div className={`menu ${open ? "open fade-in-4" : ""}`}>
          <Link to="/services" onClick={() => setOpen(false)}>
            SERVICES
          </Link>
          <Link to="/about-us" onClick={() => setOpen(false)}>
            ABOUT US
          </Link>
          <Link to="/contact" onClick={() => setOpen(false)}>
            CONTACT
          </Link>
          <Link to="/gallery" onClick={() => setOpen(false)}>
            GALLERY
          </Link>
          <Link to="/faq" onClick={() => setOpen(false)}>
            FAQ
          </Link>
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
